import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { SubmissionError } from 'redux-form';
import NotificationSystem from 'rc-notification';
import MenuItem from 'components/Menu/MenuItem';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';
import BasicNotification from 'components/Notification';
import { NYLAS_ERRORS } from 'constants/errors';
import { NOTIFICATION_NODE_STYLE } from 'constants/misc';
import DialogContent from '@material-ui/core/DialogContent';
import { updateEmailImapSmtpConfig, getAccountEmailConfigs } from 'redux/actions/emailConfigActions';
import EmailImapSmtpConfigForm from './EmailImapSmtpConfigForm';

class EmailImapSmtpConfigUpdate extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    updateEmailImapSmtpConfig: PropTypes.func.isRequired,
    getAccountEmailConfigs: PropTypes.func.isRequired,
    accountId: PropTypes.string.isRequired,
    emailConfigId: PropTypes.string.isRequired,
    initialValues: PropTypes.shape({
      sender_name: PropTypes.string,
      total_number_of_emails_per_day: PropTypes.number,
      delay_between_each_email_sent: PropTypes.number,
      is_primary: PropTypes.bool,
      error_type: PropTypes.string,
      imap_config: PropTypes.shape({
        username: PropTypes.string,
        host: PropTypes.string,
        port: PropTypes.number,
        is_ssl_enabled: PropTypes.bool,
      }),
      smtp_config: PropTypes.shape({
        username: PropTypes.string,
        host: PropTypes.string,
        port: PropTypes.number,
        is_ssl_enabled: PropTypes.bool,
      }),
    }).isRequired,
    closeMenu: PropTypes.func,
  };

  static defaultProps = {
    className: '',
    closeMenu: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.openModal = this.openModal.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    // eslint-disable-next-line no-return-assign
    NotificationSystem.newInstance({ style: { zIndex: '9999' } }, n => this.notification = n);
  }

  async onSubmit(formData) {
    try {
      await this.props.updateEmailImapSmtpConfig(
        this.props.accountId,
        this.props.emailConfigId,
        {
          sender_name: formData.sender_name,
          total_number_of_emails_per_day: formData.total_number_of_emails_per_day,
          delay_between_each_email_sent: formData.delay_between_each_email_sent,
          is_primary: formData.is_primary,
          reply_to_email: formData.reply_to_email,
          imap_config: {
            username: formData.imap_config.username,
            password: formData.imap_config.password,
            host: formData.imap_config.host,
            port: formData.imap_config.port,
            is_ssl_enabled: formData.imap_config.is_ssl_enabled,
          },
          smtp_config: {
            username: formData.smtp_config.username,
            password: formData.smtp_config.password,
            host: formData.smtp_config.host,
            port: formData.smtp_config.port,
            is_ssl_enabled: formData.smtp_config.is_ssl_enabled,
          },
        },
      );
      this.toggle();
      await this.props.getAccountEmailConfigs(this.props.accountId);
    } catch (error) {
      if (error.errors) {
        const nonFieldErrors = error.errors.non_field_errors;
        if (nonFieldErrors) {
          /* eslint-disable-next-line no-underscore-dangle */
          error.errors._error = nonFieldErrors;
        }
        throw new SubmissionError(error.errors);
      }
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  openModal() {
    this.props.closeMenu();
    this.toggle();
  }

  showNotification = (message) => {
    this.notification.notice({
      content: <BasicNotification
        color="danger"
        message={message}
      />,
      duration: 2,
      closable: false,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    });
  }

  render() {
    return (
      <React.Fragment>
        <MenuItem onClick={this.openModal}>
          { NYLAS_ERRORS.includes(this.props.initialValues.error_type) ? 'Reconnect' : 'Edit' }
        </MenuItem>
        <div className={this.props.className}>
          {NYLAS_ERRORS.includes(this.props.initialValues.error_type)
            && this.state.isOpen
            && this.showNotification('Email config is invalid, please update and reconnect.')
          }
          <Dialog
            open={this.state.isOpen}
            onBackdropClick={this.toggle}
            size="large"
          >
            <DialogTitle id="dialog-title" disableTypography>
              Update IMAP/SMTP email config
            </DialogTitle>
            <DialogContent>
              <EmailImapSmtpConfigForm
                actionType="update"
                toggleModal={this.toggle}
                onSubmit={data => this.onSubmit(data)}
                initialValues={this.props.initialValues}
              />
            </DialogContent>
          </Dialog>
        </div>
      </React.Fragment>
    );
  }
}

export default compose(
  connect(
    state => ({
      config: state.config,
    }),
    { updateEmailImapSmtpConfig, getAccountEmailConfigs },
  ),
  withNamespaces('common'),
)(EmailImapSmtpConfigUpdate);
